import { useParams } from 'react-router-dom';
import { IncidentDetailPageView } from './IncidentDetailPageView';

export function IncidentDetailPageContainer() {
  const { incidentId = '' } = useParams<{ incidentId: string }>();
  return <IncidentDetailPageView incidentId={incidentId} />;
}
